<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="addPdfFile" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.file.$invalid" :vm-active="isModalPurchaseOrdersVisible" :vm-title='getTitle')
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.file.$invalid },]")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
            b-form-group
                input(@change="setFile" text="Orden de Compra" type="file")
</template>
<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import Uploader from 'vux-uploader-component'
const { mapGetters, mapActions } = createNamespacedHelpers('Projects')

export default {
  name: 'ModalPurchaseOrders',
  components: {
    Uploader
  },
  mixins: [ModalMixin1],
  props: {
    selectedProjectId: {
      default: null,
      type: Number
    }
  },
  data: () => ({
    file: null
  }),
  validations () {
    return {
      file: {
        required
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'testimonials', 'isModalPurchaseOrdersVisible'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'setModalPurchaseOrders',
      'uploadPdfFile'
    ]),
    setFile (event) {
      this.file = event.target.files[0]
    },
    addPdfFile () {
      this.uploadPdfFile({ id: this.selectedProjectId, file: this.file })
      this.setModalPurchaseOrders(false)
    },
    close () {
      this.setModalPurchaseOrders(false)
    }
  }
}
</script>
<style lang="scss">
.image_section {
  padding-left: 0.5rem;
  -webkit-box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
  box-shadow: inset -33px -33px 3px -30px rgba(3,52,4,0.06);
}
.image_indicator {
  margin: 1rem 0 0 76%;
  text-align: center;
  padding: .4rem;
  width: 2rem;
  height: 2rem;
  border-top: 1px solid rgba(var(--primary),1);
  border-right: 1px solid rgba(var(--primary),1);
  border-bottom: 1px solid rgba(var(--primary),1);
  border-left: 1px solid rgba(var(--primary),1);
  border-radius: 100%;
}
.images_container {
  padding-left: 1.3rem;
}
</style>
